export default __webpack_public_path__ + "static/media/awsIcon.6ea66640.png";